import { hashCode } from "src/components/js/statics1";

export default class toimitusBetoniClass {
  constructor() {
    this.toimitusBetoniId = 0;
    this.toimitusId = 0;
    this.keikkaBetoniId = 0;
    this.m3 = 0;
    this.minutes = 0;
    this.startTime = null;
    this.endTime = null;
    this.vehicleRegNo = "";
    this.vehicleNo = "";
    this.kkNumber = "";
    this.comments = "";
    this.isLoaded = true;
    this.nouto = false;
  }

  get hash() {
    return hashCode(JSON.stringify(this));
  }
}
